<div aria-owns="ariaLabel"></div>

<ion-button
    class="tab m-0 box-border flex h-full min-h-[2.5rem] w-full border-b-4 border-solid text-sm !opacity-100"
    [ngClass]="{
        'orb-app-light:border-primary border-secondary font-semibold text-black dark:border-contrast-yellow dark:!text-contrast-yellow':
            isSelected,
        'border-transparent text-ironside_grey dark:text-contrast-yellow': !isSelected
    }"
    [attr.aria-label]="''"
    fill="clear">
    <div
        class="flex-align-center flex h-full w-full justify-center"
        [class.normal-case]="env.REMOVE_UPPERCASE"
        [attr.aria-label]="getAriaLabel()">
        <ng-content> </ng-content>
    </div>
</ion-button>
